import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TableColumn } from '@ui/aos-lib';
import { DeviceType } from '../../devices/components/devices.models';
import { getUrlPathForDeviceTypeName } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model.helpers';
import { BaseStationItemListResponseDto } from '../base-stations-listing-page.types';

@Component({
  selector: 'aos-device-id-column',
  template: `
    @if (item) {
      @if (item.deviceUID) {
        <a
          [routerLink]="getLink(item.deviceUID)"
          [relativeTo]="null"
        >
          {{ item.deviceId }}
        </a>
      } @else {
        <span>{{ item.deviceId }}</span>
      }
    }
  `,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeviceIdColumnComponent {
  @Input() item!: BaseStationItemListResponseDto;
  @Input() column!: TableColumn;

  protected getLink(deviceUID: string): string {
    return `devices/${getUrlPathForDeviceTypeName(DeviceType.BaseStation)}/${deviceUID}`;
  }
}
